<div class="personal-data">
  <!-- الجزء العلوي -->
  <div class="header">
    <div class="image-wrapper">
      <img *ngIf="userImage; else defaultAvatar" [src]="userImage" alt="Profile Picture" />
      <ng-template #defaultAvatar>
        <div class="avatar-placeholder">{{ userService.getUserInitials() }}</div>
      </ng-template>
      <label class="edit-icon">
        <input type="file" hidden (change)="onImageChange($event)" />
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="16" viewBox="0 0 15 16" fill="none">
          <g clip-path="url(#clip0_137_139)">
            <path
              d="M14.5872 4.66284L13.2366 6.01343C13.0989 6.15112 12.8763 6.15112 12.7386 6.01343L9.48661 2.76147C9.34892 2.62378 9.34892 2.40112 9.48661 2.26343L10.8372 0.912842C11.385 0.36499 12.2757 0.36499 12.8265 0.912842L14.5872 2.67358C15.138 3.22144 15.138 4.11206 14.5872 4.66284ZM8.32646 3.42358L0.633095 11.1169L0.0120011 14.6765C-0.0729598 15.157 0.345986 15.573 0.826454 15.491L4.38602 14.8669L12.0794 7.17358C12.2171 7.03589 12.2171 6.81323 12.0794 6.67554L8.82743 3.42358C8.68681 3.28589 8.46415 3.28589 8.32646 3.42358ZM3.63602 10.4578C3.47489 10.2966 3.47489 10.0388 3.63602 9.87769L8.14774 5.36597C8.30888 5.20483 8.56669 5.20483 8.72782 5.36597C8.88895 5.5271 8.88895 5.78491 8.72782 5.94605L4.2161 10.4578C4.05497 10.6189 3.79716 10.6189 3.63602 10.4578ZM2.57841 12.9216H3.98466V13.9851L2.09501 14.3162L1.18388 13.405L1.51493 11.5154H2.57841V12.9216Z"
              fill="white" />
          </g>
          <defs>
            <clipPath id="clip0_137_139">
              <rect width="15" height="15" fill="white" transform="translate(0 0.5)" />
            </clipPath>
          </defs>
        </svg>
      </label>
    </div>

    <div class="user-info">
      <h3>{{ profileForm.get('fullName')?.value || 'User Name'| translate }}</h3>
      <p class="hint"> {{ 'profile.imageHint' | translate }}</p>
    </div>
  </div>
  <form [formGroup]="profileForm" class="form-section mt-3">
    <div class="form-grid">
      <div class="form-row">
        <label>{{ 'profile.fullName' | translate }}</label>
        <div class="input-wrapper">
          <i class="fa fa-user"></i>
          <input formControlName="fullName" type="text" [placeholder]="'profile.fullNamePlaceholder' | translate" />
        </div>
      </div>

      <div class="form-row">
        <label>{{ 'profile.phone' | translate }}</label>
        <div class="input-wrapper">
          <i class="fa fa-phone"></i>
          <input formControlName="phone" type="text" [placeholder]="'profile.phonePlaceholder' | translate" />
        </div>
      </div>

      <div class="form-row">
        <label>{{ 'profile.email' | translate }}</label>
        <div class="input-wrapper">
          <i class="fa fa-envelope"></i>
          <input formControlName="email" type="email" [placeholder]="'profile.emailPlaceholder' | translate" />
        </div>
      </div>

      <div class="form-row">
        <label>{{ 'profile.country' | translate }}</label>
        <div class="input-wrapper custom-dropdown-wrapper" #countryTrigger>
          <i class="fa fa-globe"></i>
          <div class="custom-select-trigger" (click)="toggleCountryDropdown()">
            <span>{{ profileForm.get('country')?.value || ('profile.selectCountry' | translate) }}</span>
            <i class="fa fa-chevron-down chevron-icon" [class.rotated]="showCountryDropdown"></i>
          </div>
          <div class="country-dropdown" *ngIf="showCountryDropdown">
            <div class="country-search-wrapper">
              <i class="fa fa-search country-search-icon"></i>
              <input type="text" class="country-search-input" placeholder="Search..."
                [(ngModel)]="countrySearch" [ngModelOptions]="{ standalone: true }"
                (click)="$event.stopPropagation()" />
            </div>
            <ul class="country-list">
              <li *ngFor="let country of filteredCountries" (click)="selectCountry(country)"
                [class.active]="profileForm.get('country')?.value === country">
                <span class="country-name">{{ country }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <hr class="form-divider" />

    <div class="buttons">
      <button type="button" class="cancel" (click)="onCancel()"> {{ 'common.cancel' | translate }}</button>
      <button type="button" class="save" (click)="onSave()"> {{ 'common.save' | translate }}</button>
    </div>
  </form>

</div>